import { useState } from 'react';
import { apiRaw, enc, type Lot } from '../api';
import { ScanField } from '../components/ScanField';
import { ErrorBox } from '../components/ui';
import { LotView } from './LotDetail';

/** Scan a preprinted lot label to see that exact lot and its current location. */
export function FindLotPage() {
  const [lot, setLot] = useState<Lot | null>(null);
  const [miss, setMiss] = useState<{ code: string; hint: string | null } | null>(null);
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  const scan = async (code: string) => {
    setBusy(true);
    setMiss(null);
    setError(null);
    try {
      const { status, body } = await apiRaw(`/scan/lot/${enc(code)}`);
      if (status === 200) setLot(body.lot);
      else if (status === 404) {
        setLot(null);
        setMiss({ code: body?.code ?? code, hint: body?.hint ?? null });
      } else setError(new Error(body?.error?.message ?? `Lookup failed (${status})`));
    } catch (e) {
      setError(e);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="narrow">
        <h1>Find lot</h1>
        <ScanField kind="lot" onScan={scan} busy={busy} autoFocus />
        <ErrorBox error={error} />
        {miss && (
          <div className="alert alert-warn">
            No lot has label <strong className="mono">{miss.code}</strong>.{miss.hint ? ` ${miss.hint}` : ''}
          </div>
        )}
      </div>
      {lot && <LotView lot={lot} setLot={setLot} />}
    </div>
  );
}
